import isNil from 'lodash/isNil';

// TODO: add tests
/**
 * A function for negating predicates
 * @param predicate
 */
export const not = (predicate: (value: any) => boolean) => (value: any) => !isNil(value) && !predicate(value);
